import styled from "styled-components";
import { applyGradient } from "../../../styled/blue-gradient-background";

export const AuthPageContainer = styled.div`
  ${applyGradient()}
  min-height:100vh;
`;
